// extracted by mini-css-extract-plugin
export default {"header-row":"styles_header-row__vLX4S","filter-row":"styles_filter-row__8PQj0","teamsGrid":"styles_teamsGrid__HvYW6","loading-spacer":"styles_loading-spacer__YyZh9"};